import type { SVGProps } from 'react';
const SvgPerson = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height={24}
    viewBox="0 0 24 24"
    width={24}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7C17 8.32608 16.4732 9.59785 15.5355 10.5355C14.5979 11.4732 13.3261 12 12 12C10.6739 12 9.40215 11.4732 8.46447 10.5355C7.52678 9.59785 7 8.32608 7 7C7 5.67392 7.52678 4.40215 8.46447 3.46447ZM12 3.25C11.0054 3.25 10.0516 3.64509 9.34835 4.34835C8.64509 5.05161 8.25 6.00544 8.25 7C8.25 7.99456 8.64509 8.94839 9.34835 9.65165C10.0516 10.3549 11.0054 10.75 12 10.75C12.9946 10.75 13.9484 10.3549 14.6517 9.65165C15.3549 8.94839 15.75 7.99456 15.75 7C15.75 6.00544 15.3549 5.05161 14.6517 4.34835C13.9484 3.64509 12.9946 3.25 12 3.25ZM12 13.875C10.0109 13.875 8.10322 14.6652 6.6967 16.0717C5.29018 17.4782 4.5 19.3859 4.5 21.375C4.5 21.7202 4.22018 22 3.875 22C3.52982 22 3.25 21.7202 3.25 21.375C3.25 19.0544 4.17187 16.8288 5.81282 15.1878C7.45376 13.5469 9.67936 12.625 12 12.625C14.3206 12.625 16.5462 13.5469 18.1872 15.1878C19.8281 16.8288 20.75 19.0544 20.75 21.375C20.75 21.7202 20.4702 22 20.125 22C19.7798 22 19.5 21.7202 19.5 21.375C19.5 19.3859 18.7098 17.4782 17.3033 16.0717C15.8968 14.6652 13.9891 13.875 12 13.875Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgPerson;
